import React from 'react';
import { Dropdown } from "primereact/dropdown";

export const SingleSelectDropdown = (props) => {
  return (
    <span className={`p-float-label w-full md:w-14rem ${props.className}`}>
        <Dropdown
            value={props.selectedValue}
            onChange={(e) => props.setSelectedValue(e.value)}
            options={props.options}
            className="w-full md:w-14rem"
            id={props.eleId}
            style={props.styles}
            />
        <label htmlFor={props.eleId}>{props.label}</label>
    </span>
  )
}
